import { makeStyles, Theme } from '@material-ui/core/styles';

export const useStyles = makeStyles((theme: Theme) => ({
  box: {
    width: '100%',
  },
  boxTitle: {
    fontSize: 20,
    fontWeight: 500,
    marginBottom: theme.spacing(3),
  },
  paper: {
    backgroundColor: '#ffffff',
    padding: theme.spacing(3),
    boxShadow: theme.shadows[0],
    width: 'calc(50% - 12px)',
    marginBottom: theme.spacing(2),
  },
  row: {
    position: 'relative',
    alignItems: 'center',
    justifyContent: 'space-between',
    marginBottom: theme.spacing(3.5),
  },
  rows: {
    position: 'relative',
    alignItems: 'center',
    // justifyContent: 'space-between',
    marginBottom: theme.spacing(1),
  },
  notify: {
    '& .MuiTypography-body1 ': {
      fontSize: '14px',
    },
  },
  halfSizeRow: {
    position: 'relative',
    alignItems: 'center',
    justifyContent: 'space-between',
    marginBottom: theme.spacing(3.5),
  },
  rowWide: {
    position: 'relative',
    justifyContent: 'space-between',
    marginBottom: theme.spacing(3.5),
  },
  title: {
    margin: theme.spacing(0, 3.5, 0, 0),
    fontSize: 14,
    letterSpacing: 0.15,
    color: 'rgb(0 0 0 / 54%)',
  },
  titles: {
    margin: theme.spacing(0, 0, 0, 0),
    fontSize: 14,
    width: '95px',
    lineHeight: '45px',
    letterSpacing: 0.15,
    color: 'rgb(0 0 0 / 54%)',
  },
  input: {
    width: 'calc(100% - 170px)',
    color: 'rgb(0 0 0 / 87%)',
    '&:before': {
      borderBottom: '1px solid #E0E0E0',
    },
    '& label': {
      transform: 'translate(0, 0)',
      '& + div': {
        margin: 0,
      },
    },
  },
  btnBox: {
    display: 'flex',
    justifyContent: 'flex-start',
  },
  btnWide: {
    padding: theme.spacing(1, 5),
    fontSize: 14,
    textTransform: 'none',
  },
  btnWideLeft: {
    padding: theme.spacing(1, 5),
    fontSize: 14,
    background: '#FF505F',
    color: 'white',
    textTransform: 'none',
    marginRight: 10,
  },
  tableBox: {
    width: '100%',
    padding: 0,
  },
}));
